import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { onlyContent } = {}) => ({
  viewButtonGap: { marginRight: 16 },
  viewButtonGapWide: { marginRight: 38 },
  bar: {
    backgroundColor: 'white',
    margin: '0 auto',
    maxWidth: 1180,
    position: 'sticky',
    padding: `40px 26px 12px`,
    top: 50,
    zIndex: 100,
    [theme.breakpoints.down('lg')]: {
      top: onlyContent ? 0 : 40,
    },
    [theme.breakpoints.down('md')]: {
      top: 50,
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)} 12px`,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        top: onlyContent ? 0 : 40,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        top: 50,
        padding: `${theme.spacing(1)} ${theme.spacing(1.5)} 12px`,
      }),
    },
  },
  switcher: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 22,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1.5),
      }),
    },
  },
  switch: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: -4,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginLeft: -4,
      }),
    },
  },
  filtersBox: {
    display: 'flex',
    marginBottom: theme.spacing(2.5),
    width: '100%',
    '& > div': {
      margin: theme.spacing(1),
    },
    '& > div:nth-child(1)': {
      order: 0,
    },
    '& > div:nth-child(2)': {
      order: 1,
    },
    '& > div:nth-child(3)': {
      order: 2,
    },
    '& > div:nth-child(4)': {
      order: 3,
    },
    '& > div:nth-child(5)': {
      order: 4,
    },
    '& > div:nth-child(6)': {
      order: 5,
    },
    [theme.breakpoints.down('xl')]: {
      flexWrap: 'wrap',
      maxWidth: 830,
      '& > div': {
        margin: 5,
      },
      '& > div:nth-child(6)': {
        order: 4,
      },
      '& > div:nth-child(5)': {
        order: 5,
      },
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: 650,
      '& > div:nth-child(6)': {
        order: 3,
      },
      '& > div:nth-child(4)': {
        order: 4,
      },
    },
    [theme.breakpoints.downLandscape('xl')]: {
      ...(theme.isMobileDevice && {
        flexWrap: 'wrap',
        maxWidth: 830,
        '& > div': {
          margin: 5,
        },
        '& > div:nth-child(6)': {
          order: 4,
        },
        '& > div:nth-child(5)': {
          order: 5,
        },
      }),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        maxWidth: 650,
        '& > div:nth-child(6)': {
          order: 3,
        },
        '& > div:nth-child(4)': {
          order: 4,
        },
      }),
    },
  },
}));
